
import { RoadRage } from "../../RoadRage";
import { stickyFS } from '../../server/data/IData';
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { GameData, InitData } from "../../server/data/BaseModel";
import { GameMode } from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { Presentation, PresentationState } from "../../../dev/gameflow/controller/Presentation";
import { ReelGameData, WinGameData } from '../../server/data/GameDataModels';
import { PresentationController } from '../../../dev/gameflow/controller/PresentationController';
import { StartPresentation } from '../general/StartPresentation';
import { BonusCounters } from '../../independent/countup/BonusCounters';
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';

export class FSIdlePresentation extends Presentation {

    private fsLeft: number = 0;
    private stickyWilds: boolean = false;
    private willUpdateZeroBet: boolean = false;

    private nextSpinStickies: stickyFS[] = [];

    private _gameData:ReelGameData;

    private respinRestore:boolean = false;
    private playStickySound:boolean = false;

    private delayWins:boolean = false;

    public checkForActivation(data: GameData | InitData): boolean { return data.mode != GameMode.NORMAL || data.nextMode != GameMode.NORMAL; }

    public setInitData(data: InitData): void {
        if (data.gameModeChanges && data.mode != GameMode.NORMAL) {
            this.PresentationState.set(PresentationState.ACTIVATED);
        }
        this.respinRestore = data.nextMode === GameMode.RESPIN && data.isRestoreState;
    }

    public setGamedData(data: GameData) {
        this._gameData = data.Reel;
        this.fsLeft = data.raw.freespinsLeft === 1 ? -1 : data.raw.freespinsLeft - 1;
        this.willUpdateZeroBet = (data.isFreeSpin || data.isNextFS) && !data.nextModeSetup;

        this.nextSpinStickies = data.Reel.stickWildPos;

        this.stickyWilds = data.gameModeChanges;
        this.respinRestore = data.nextIsRespin && data.isRestoreState;

        this.delayWins = !!data.Win.singleWin;
        
        if(data.isFreeSpin){
            this.playStickySound = !!this._gameData.carMoveInfo.filter((c) =>{
                return this._gameData.CarsFSAvailable.indexOf(c.type) >= 0;
            }).length;
        }
    }
 
    public createPresentation(skipCB: Function): void {
        skipCB(false);

        if(this.respinRestore){
            SoundManager.onBet(3)
            this.timeline.add(BonusCounters.instance.playMessage("Respin Triggered"));
            this.respinRestore = false;
        }
        
        else if(!StartPresentation.restoreStarted){
            this._gameData.saveLastStickes(this.stickyWilds);

            RoadRage.counter.stop(undefined, undefined, 0, true);
            RoadRageEngineManager.RSAll((rc, sym) => sym.stopWin(0.2));

            this.timeline.to(this,{duration: this.delayWins ? 0.25 : 0.1});

            if(!this.stickyWilds)
                this.nextSpinStickies.forEach(sWild => RoadRageEngineManager.getReel(sWild.reel).setSticky([sWild.row]));

            if(this.playStickySound)
                SoundManager.playSoundEffect(SoundConfig.CAR_STICKY)
        }

        this.PresentationState.setInactive();
    }

    public done(): void {
        this._gameData.saveLastStickes(false);
        if (this.willUpdateZeroBet) {
            SlotGame.keypadPlugin.setZeroBetSpinCounter(this.fsLeft);
        }

        SlotGame.apiPlugin.betHandler.zeroBet();
    }
}